import { Component, inject } from '@angular/core';
import { MachineClawChangeHistoricService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  MachineClawChangeHistoricCreateDto,
  MachineClawChangeHistoricDto,
  MachineClawChangeHistoricExcelDownloadDto,
  MachineClawChangeHistoricUpdateDto,
} from '../proxy/general/dtos/machine-claw-change-historic';
import { MACHINECLAWCHANGEHISTORIC_CONFIG, MACHINECLAWCHANGEHISTORIC_FIELDS } from './machine-claw-change-historic.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-machine-claw-change-historic',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, MachineClawChangeHistoricService, ConfirmationService],
  templateUrl: './machine-claw-change-historic.html',
  styleUrl: './machine-claw-change-historic.scss',
})
export class MachineClawChangeHistoric extends BaseHierarchicalCrudComponent<
  MachineClawChangeHistoricDto,
  MachineClawChangeHistoricCreateDto,
  MachineClawChangeHistoricUpdateDto,
  MachineClawChangeHistoricExcelDownloadDto
> {
  service = inject(MachineClawChangeHistoricService);
  config = MACHINECLAWCHANGEHISTORIC_CONFIG;
  fields = MACHINECLAWCHANGEHISTORIC_FIELDS;

  protected prepareUpdateDto(data: any, selected: MachineClawChangeHistoricDto): MachineClawChangeHistoricUpdateDto {
    return {
      dateFrom: data.dateFrom,
      dateTo: data.dateTo,
      machineId: data.machineId,
      clawId: data.clawId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'MachineClawChangeHistoric';
  }
}
